import React from "react";
import { motion } from "framer-motion";

/**
 * Da Vinci-style hand-drawn cigar / botanical sketch.
 * Lines are animated by Framer Motion via pathLength.
 */
export default function DaVinciSketch({ className = "", drawDelay = 0.2 }) {
  const stroke = "#B08D57";
  const ease = [0.65, 0, 0.35, 1];

  const path = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: (i = 0) => ({
      pathLength: 1,
      opacity: 0.7,
      transition: { delay: drawDelay + i * 0.25, duration: 2.4, ease },
    }),
  };

  return (
    <motion.svg
      viewBox="0 0 600 600"
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.35 }}
      fill="none"
      stroke={stroke}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* central stem */}
      <motion.path d="M300 70 Q302 300 296 530" custom={0} variants={path} />
      {/* left leaf */}
      <motion.path
        d="M296 220 Q160 200 110 320 Q160 360 296 330 Z"
        custom={1}
        variants={path}
      />
      {/* right leaf */}
      <motion.path
        d="M300 280 Q440 250 500 380 Q440 430 298 380 Z"
        custom={2}
        variants={path}
      />
      {/* lower leaf */}
      <motion.path
        d="M298 420 Q200 460 220 540 Q260 560 298 510 Z"
        custom={3}
        variants={path}
      />
      {/* veins */}
      <motion.path d="M296 240 Q220 270 130 320" custom={4} variants={path} strokeOpacity="0.55" />
      <motion.path d="M298 295 Q380 290 480 380" custom={5} variants={path} strokeOpacity="0.55" />
      <motion.path d="M298 440 Q260 475 230 525" custom={6} variants={path} strokeOpacity="0.55" />

      {/* annotations */}
      <motion.circle cx="120" cy="312" r="3" fill={stroke} stroke="none" custom={7} variants={path} />
      <motion.path d="M120 312 L60 312" custom={7} variants={path} strokeOpacity="0.5" />
      <motion.text
        x="20"
        y="316"
        fill={stroke}
        fillOpacity="0.7"
        stroke="none"
        fontSize="9"
        fontFamily="Space Mono, monospace"
        letterSpacing="2"
      >
        VOL.
      </motion.text>

      <motion.circle cx="500" cy="380" r="3" fill={stroke} stroke="none" custom={8} variants={path} />
      <motion.path d="M500 380 L560 380" custom={8} variants={path} strokeOpacity="0.5" />
      <motion.text
        x="540"
        y="372"
        fill={stroke}
        fillOpacity="0.7"
        stroke="none"
        fontSize="9"
        fontFamily="Space Mono, monospace"
        letterSpacing="2"
      >
        SEC.
      </motion.text>

      <motion.text
        x="40"
        y="60"
        fill={stroke}
        fillOpacity="0.6"
        stroke="none"
        fontSize="10"
        fontFamily="Space Mono, monospace"
        letterSpacing="3"
      >
        NICOTIANA · TABACUM · CIBAO
      </motion.text>
      <motion.text
        x="40"
        y="588"
        fill={stroke}
        fillOpacity="0.6"
        stroke="none"
        fontSize="9"
        fontFamily="Space Mono, monospace"
        letterSpacing="2"
      >
        FOLIO · 014 / 1956
      </motion.text>
    </motion.svg>
  );
}
